// ----------------------------------------------------------------------
export const Radio = () => {
    return {
        MuiRadio: {
            defaultProps: {
                color: 'primary'
            },
            styleOverrides: {
                root: {
                    padding: 8
                }
            }
        }
    };
};
//# sourceMappingURL=Radio.js.map